/** @jsxImportSource react */

import cx from 'classnames';
import { bool, func, string } from 'proptypes';
import React, { forwardRef, useCallback } from 'react';

import Button from '../Button';

const getColors = (disabled, value, palette, [background, active]) => {
  const result = [];
  if (disabled) {
    result.push('text-slate-base', 'bg-slate-lighter-20');
  }

  const baseColor = `text-${palette}-base`;

  if (value) {
    result.push(baseColor);
    result.push(`bg-${active}`);
    result.push(`border-${palette}-base`);
  } else {
    result.push('text-slate-base');
    result.push(background);
    result.push('border-slate-lighter-90');
  }

  result.push(`hover:text-${palette}-base`);
  result.push(`hover:border-current`);

  result.push(`active:text-${palette}-base`);
  result.push(`active:bg-${active}`);
  return result.join(' ');
};

const getStyles = ({ palette, value, disabled }) => {
  return getColors(disabled, value, palette, [
    'white',
    `${palette}-lighter-90`,
  ]);
};

const ToggleButton = forwardRef((props, ref) => {
  const onChange = useCallback(
    () => props.onChange(!props.value),
    [props.onChange, props.value]
  );

  const { className } = props;

  return (
    <Button
      {...props}
      ref={ref}
      className={cx(
        '!flex !items-center !justify-center',
        'rounded-box font-b-m box-border',
        'cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap',
        '!py-0 !px-0 focus:outline-none',
        getStyles(props),
        className
      )}
      variant='neutral'
      onClick={props.to && !onChange ? null : onChange}
      data-tp-id='gen-Button-5e7b9482-0318-453b-9f90-9674b74be051'
    />
  );
});

ToggleButton.propTypes = {
  palette: string,
  value: bool,
  disabled: bool,
  onChange: func,
  to: string,
};

ToggleButton.defaultProps = {
  palette: 'viridian',
};

export default ToggleButton;
